<template>
  <div class="result-teaser">
    <div class="result-teaser__header">
      <div
        class="result-teaser__image"
        :style="`background-image: url(${getProductImage()});`"
      ></div>

      <h2 class="result-teaser__headline size--xl">
        <span>Tektalan A2</span>
        <b>{{name}}</b>
        <small v-if="format">{{ format }} </small>
      </h2>
    </div>

    <h4 class="props">Eigenschaften</h4>

    <ul class="feature-list">
      <li
        :class="['feature-list__item', !feature.active ? 'feature-list__item--inactive' : null]"
        v-for="(feature, index) in features" v-bind:key="index"
      >
        <Icon class="feature-list__icon" set="features" :id="feature.icon" />

        <div class="feature-list__text">
          <div>{{feature.type}}</div>
          <b>{{feature.value}}</b>
        </div>
      </li>
    </ul>
    <div class="button-wrapper">
      <Button variant="primary" :url="product_url" external text="Zur Produktseite" />
      <Button variant="secondary" :url="specification_url" external text="Ausschreibungstext" />
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import Button from '@/components/Button.vue';

export default {
  components: {
    Icon,
    Button,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    format: {
      type: String,
      required: false,
    },
    image: {
      type: String,
      required: true,
    },
    features: {
      type: Array,
      required: true,
    },
    product_url: {
      type: String,
      required: true,
    },
    specification_url: {
      type: String,
      required: true,
    },
  },
  methods: {
    getProductImage() {
      // Yes this is necessary
      // eslint-disable-next-line
      return require(`@/assets/img/products/${this.image}`);
    },
  },
};
</script>

<style scoped lang="scss">
small {
  font-weight: normal;
  font-family: "Futura Regular", Helvetica, Verdana, sans-serif;
  font-size:  16px;
}
.result-teaser {
  background-color: $color-white;
  padding: 25px;
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: left;

  &__header {
    margin-bottom: 30px;
    display: flex;
  }

  &__image {
    background: no-repeat center;
    background-size: contain;
    height: 100px;
    flex-basis: 100px;
  }

  &__headline {
    margin-bottom: 0;
    padding-left: 15px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;

    span {
      display: block;
      font-family: $font-regular;
      font-weight: normal;
    }
  }
}

.feature-list {
  margin: 0 0 30px;
  padding: 0;
  list-style: none;

  &__item {
    margin-bottom: 15px;
    display: flex;
    align-items: center;

    &:last-child {
      margin-bottom: 0;
    }

    &--inactive {
      color: #999;

      svg {
        filter: grayscale(100%);
      }
    }
  }

  &__icon {
    flex-basis: 30px;
  }

  &__text {
    padding-left: 15px;
    flex: 1;
  }
}
.props {
  margin: 0px 0px 20px 0px
}
.button-wrapper {
  justify-content: flex-end;
  align-items:  stretch;
  flex-direction: column;
  flex: 1;
  display: flex;
}
</style>
